import { render, staticRenderFns } from "./SaleReturnItem.vue?vue&type=template&id=54ddc3b1&scoped=true&"
import script from "./SaleReturnItem.vue?vue&type=script&lang=js&"
export * from "./SaleReturnItem.vue?vue&type=script&lang=js&"
import style0 from "./SaleReturnItem.vue?vue&type=style&index=0&id=54ddc3b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ddc3b1",
  null
  
)

export default component.exports